module.exports = __webpack_public_path__ + "static/media/to-nie-tylko-bajki.7df3f02e.jpg";